import { FC, ReactNode } from "react";
import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { SxProps, useTheme } from "@mui/material/styles";
import Text from "./Text";

interface DottedTextFieldProps {
  placeholder: string;
  value: number | string | ReactNode;
  withoutDotted?: boolean;
  children?: ReactNode;
  fullWidth?: boolean;
  valueColor?: string;
  sx?: SxProps;
}

const DottedTextField: FC<DottedTextFieldProps> = ({
  placeholder,
  value,
  children,
  fullWidth = true,
  valueColor,
  withoutDotted,
  sx,
}) => {
  const theme = useTheme();

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      spacing={"4px"}
      width={{ width: `${fullWidth ? "100%" : "auto"}` }}
      sx={sx}
    >
      <Text variant="regular" sx={{ opacity: "0.5" }}>
        {placeholder}
      </Text>
      {!withoutDotted && (
        <Box
          sx={{
            top: "6px",
            flex: 1,
            position: "relative",
            borderBottom: `1px dashed ${theme.myTheme.colors.foreground20}}`,
          }}
        />
      )}
      <Stack direction={"row"} alignItems={"center"}>
        <Text color={valueColor} variant="regular">
          {value}
        </Text>
        {children}
      </Stack>
    </Stack>
  );
};

export default DottedTextField;
